export class DespesaDTO {
  postoId: number;
  funcionarioId: number;
  transferenciaId: number;
  tipoDespesa: String;
  categoria: String;
  valor: number;
  segundoValor: number;
}
